export const EXPORT_LEADS_ON_EMAIL="EXPORT_LEADS_ON_EMAIL"
export const EXPORT_LEADS_ON_EMAIL_SUCCESS="EXPORT_LEADS_ON_EMAIL_SUCCESS"
export const EXPORT_LEADS_ON_EMAIL_ERROR="EXPORT_LEADS_ON_EMAIL_ERROR"

export const EXPORT_CALLS_ON_EMAIL="EXPORT_CALLS_ON_EMAIL"
export const EXPORT_CALLS_ON_EMAIL_SUCCESS="EXPORT_CALLS_ON_EMAIL_SUCCESS"
export const EXPORT_CALLS_ON_EMAIL_ERROR="EXPORT_CALLS_ON_EMAIL_ERROR"

export const EXPORT_PROSPECTS_ON_EMAIL="EXPORT_PROSPECTS_ON_EMAIL"
export const EXPORT_PROSPECTS_ON_EMAIL_SUCCESS="EXPORT_PROSPECTS_ON_EMAIL_SUCCESS"
export const EXPORT_PROSPECTS_ON_EMAIL_ERROR="EXPORT_PROSPECTS_ON_EMAIL_ERROR"

export const EXPORT_INVOICES_ON_EMAIL="EXPORT_INVOICES_ON_EMAIL"
export const EXPORT_INVOICES_ON_EMAIL_SUCCESS="EXPORT_INVOICES_ON_EMAIL_SUCCESS"
export const EXPORT_INVOICES_ON_EMAIL_ERROR="EXPORT_INVOICES_ON_EMAIL_ERROR"

export const EXPORT_RECEIPTS_ON_EMAIL="EXPORT_RECEIPTS_ON_EMAIL"
export const EXPORT_RECEIPTS_ON_EMAIL_SUCCESS="EXPORT_RECEIPTS_ON_EMAIL_SUCCESS"
export const EXPORT_RECEIPTS_ON_EMAIL_ERROR="EXPORT_RECEIPTS_ON_EMAIL_ERROR"
